// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feature-icon[data-v-22d5a782]{border-radius:50%;margin:.5rem}.hoverred[data-v-22d5a782]{border-radius:100%;--tw-bg-opacity:1;background-color:#adadad}@supports (color:rgb(0 0 0/0)){.hoverred[data-v-22d5a782]{background-color:rgb(173 173 173/var(--tw-bg-opacity))}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
